"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaLibrarySetting = exports.AdvancedSelectSetting = exports.SelectSetting = exports.ColorSetting = exports.TextSetting = exports.PasswordSetting = exports.StringSetting = exports.NumberRangeSetting = exports.DecimalSetting = exports.IntegerSetting = exports.NumberSetting = exports.BooleanSetting = exports.Setting = void 0;
const RuleManager_1 = require("./RuleManager");
const TypeGuards_1 = require("./TypeGuards");
class Setting {
    constructor(key, label) {
        this.visible = true;
        this.fixed = false;
        this.required = false;
        this.description = undefined;
        this.secret = false;
        this.order = 100;
        this.layout = "default";
        this.alignment = "left";
        this.conditions = [];
        this.debounce = false;
        this.disabled = false;
        this.readonly = false;
        this.key = key;
        this.label = label;
    }
    getDefaultValue() {
        return this.defaultValue;
    }
    extract(value) {
        return Setting.extract(value);
    }
    isVisible(values) {
        let isVisible = this.visible;
        if (isVisible && typeof values === "object") {
            this.conditions.forEach((condition) => {
                if (condition.type !== "disable") {
                    if (Array.isArray(condition.value)) {
                        let conditionOk = false;
                        condition.value.forEach((value) => {
                            if (values[condition.setting] === value) {
                                conditionOk = true;
                            }
                        });
                        if (!conditionOk) {
                            isVisible = false;
                        }
                    }
                    else if (values[condition.setting] !== condition.value) {
                        isVisible = false;
                    }
                }
            });
        }
        return isVisible;
    }
    isDisabled(values) {
        let isDisabled = this.fixed || this.disabled;
        if (!isDisabled && typeof values === "object") {
            this.conditions.forEach((condition) => {
                if (condition.type === "disable") {
                    if (Array.isArray(condition.value)) {
                        let conditionOk = false;
                        condition.value.forEach((value) => {
                            if (values[condition.setting] === value) {
                                conditionOk = true;
                            }
                        });
                        if (!conditionOk) {
                            isDisabled = true;
                        }
                    }
                    else if (values[condition.setting] !== condition.value) {
                        isDisabled = true;
                    }
                }
            });
        }
        return isDisabled;
    }
    static extract(value) {
        if (typeof value === "object" && value !== null)
            return value;
        return value === undefined || value === null ? "" : "" + value;
    }
    static createSettingFromData(key, data, setting = undefined) {
        if (!(setting instanceof Setting)
            && typeof data.label === "string") {
            switch (data.type) {
                case "boolean":
                    setting = new BooleanSetting(key, data.label);
                    break;
                case "string":
                    setting = new StringSetting(key, data.label);
                    break;
                case "password":
                    setting = new PasswordSetting(key, data.label);
                    break;
                case "integer":
                    setting = new IntegerSetting(key, data.label);
                    break;
                case "decimal":
                    setting = new DecimalSetting(key, data.label);
                    break;
                case "range":
                    setting = new NumberRangeSetting(key, data.label);
                    break;
                case "select":
                    setting = new SelectSetting(key, data.label);
                    break;
                case "advanced_select":
                    setting = new AdvancedSelectSetting(key, data.label);
                    break;
                case "text":
                    setting = new TextSetting(key, data.label);
                    break;
                case "color":
                    setting = new ColorSetting(key, data.label);
                    break;
                case "media_library":
                    setting = new MediaLibrarySetting(key, data.label);
                    break;
            }
        }
        if (setting instanceof Setting) {
            if ((0, TypeGuards_1.isString)(data.label)) {
                setting.label = data.label;
            }
            if ((0, TypeGuards_1.isBoolean)(data.visible)) {
                setting.visible = data.visible;
            }
            if ((0, TypeGuards_1.isBoolean)(data.fixed)) {
                setting.fixed = data.fixed;
            }
            if ((0, TypeGuards_1.isBoolean)(data.disabled)) {
                setting.disabled = data.disabled;
            }
            if ((0, TypeGuards_1.isBoolean)(data.readonly)) {
                setting.readonly = data.readonly;
            }
            if ((0, TypeGuards_1.isBoolean)(data.required)) {
                setting.required = data.required;
            }
            if ((0, TypeGuards_1.isString)(data.description)) {
                setting.description = data.description;
            }
            if ((0, TypeGuards_1.isString)(data.section)) {
                setting.section = data.section;
            }
            if ((0, TypeGuards_1.isBoolean)(data.secret)) {
                setting.secret = data.secret;
            }
            if ((0, TypeGuards_1.isInteger)(data.order)) {
                setting.order = data.order;
            }
            if ((0, TypeGuards_1.isString)(data.layout)) {
                setting.layout = data.layout;
            }
            if ((0, TypeGuards_1.isString)(data.alignment)) {
                setting.alignment = data.alignment;
            }
            if ((0, TypeGuards_1.isBoolean)(data.debounce)) {
                setting.debounce = data.debounce;
            }
            if ((0, TypeGuards_1.isString)(data.metadata)) {
                setting.metadata = data.metadata;
            }
            if ((0, TypeGuards_1.isObject)(data.conditions)) {
                Object.keys(data.conditions).forEach(function (field) {
                    if (setting !== undefined) {
                        setting.conditions.push({
                            setting: field,
                            value: data.conditions[field].value,
                            type: data.conditions[field].type
                        });
                    }
                });
            }
            if (setting instanceof NumberSetting) {
                if (setting instanceof IntegerSetting) {
                    if ((0, TypeGuards_1.isInteger)(data.default)) {
                        setting.defaultValue = data.default;
                    }
                    if ((0, TypeGuards_1.isInteger)(data.step)) {
                        setting.step = data.step;
                    }
                    if ((0, TypeGuards_1.isInteger)(data.min)) {
                        setting.minValue = data.min;
                    }
                    if ((0, TypeGuards_1.isInteger)(data.max)) {
                        setting.maxValue = data.max;
                    }
                }
                else {
                    if ((0, TypeGuards_1.isNumber)(data.default)) {
                        setting.defaultValue = data.default;
                    }
                    if ((0, TypeGuards_1.isNumber)(data.step)) {
                        setting.step = data.step;
                    }
                    if ((0, TypeGuards_1.isNumber)(data.min)) {
                        setting.minValue = data.min;
                    }
                    if ((0, TypeGuards_1.isNumber)(data.max)) {
                        setting.maxValue = data.max;
                    }
                }
                if (setting instanceof DecimalSetting) {
                    if ((0, TypeGuards_1.isInteger)(data.decimals)) {
                        setting.decimals = data.decimals;
                    }
                }
                else if (setting instanceof NumberRangeSetting) {
                    if ((0, TypeGuards_1.isBoolean)(data.show_input_field)) {
                        setting.showInputField = data.show_input_field;
                    }
                }
            }
            else if (setting instanceof StringSetting) {
                if ((0, TypeGuards_1.isString)(data.default)) {
                    setting.defaultValue = data.default;
                }
                if ((0, TypeGuards_1.isObject)(data.query_params)) {
                    Object.keys(data.query_params).forEach((param) => {
                        if (setting instanceof StringSetting) {
                            setting.queryParams.push({
                                name: param,
                                required: !!data.query_params[param].required,
                                skipEmpty: !!data.query_params[param].skip_empty,
                                value: data.query_params[param].value
                            });
                        }
                    });
                }
                if (setting instanceof SelectSetting) {
                    if ((0, TypeGuards_1.isArray)(data.options)) {
                        const options = [];
                        Object.keys(data.options).map((index) => {
                            options.push(data.options[index]);
                        });
                        setting.options = options;
                    }
                    if ((0, TypeGuards_1.isArray)(data.disableRules)) {
                        Object.keys(data.disableRules).map((index) => {
                            if (setting instanceof SelectSetting) {
                                setting.ruleManager.addRule(data.disableRules[index]);
                            }
                        });
                    }
                }
                if (setting instanceof TextSetting) {
                    if ((0, TypeGuards_1.isInteger)(data.cols)) {
                        setting.cols = data.cols;
                    }
                    if ((0, TypeGuards_1.isInteger)(data.rows)) {
                        setting.rows = data.rows;
                    }
                }
                if (setting instanceof ColorSetting) {
                    if ((0, TypeGuards_1.isString)(data.placement)) {
                        setting.placement = data.placement;
                    }
                    if ((0, TypeGuards_1.isBoolean)(data.hide_color_palette)) {
                        setting.hideColorPalette = data.hide_color_palette;
                    }
                    if ((0, TypeGuards_1.isBoolean)(data.hide_alpha)) {
                        setting.hideAlpha = data.hide_alpha;
                    }
                }
            }
            else if (setting instanceof AdvancedSelectSetting) {
                if ((0, TypeGuards_1.isObject)(data.default) && "label" in data.default && "value" in data.default) {
                    setting.defaultValue = data.default;
                }
                if ((0, TypeGuards_1.isObject)(data.option_object)) {
                    setting.option_object = data.option_object;
                }
                if ((0, TypeGuards_1.isString)(data.placeholder)) {
                    setting.placeholder = data.placeholder;
                }
                if ((0, TypeGuards_1.isString)(data.no_option_text)) {
                    setting.no_option_text = data.no_option_text;
                }
            }
        }
        if (setting instanceof MediaLibrarySetting) {
            if ('default' in data) {
                const value = data.default;
                setting.defaultValue = (typeof value === "string" || typeof value === "object") ? value : null;
            }
            if ((0, TypeGuards_1.isString)(data.mime_group)) {
                setting.mimeGroup = data.mime_group;
            }
            if ((0, TypeGuards_1.isString)(data.origin)) {
                setting.origin = data.origin;
            }
        }
        return setting;
    }
}
exports.Setting = Setting;
class BooleanSetting extends Setting {
    constructor() {
        super(...arguments);
        this.defaultValue = false;
    }
    extract(value) {
        return BooleanSetting.extract(value);
    }
    hydrate(value) {
        return BooleanSetting.hydrate(value);
    }
    static extract(value) {
        return value === true || value === 1 || value === "1" ? "1" : "0";
    }
    static hydrate(value) {
        return !!value;
    }
}
exports.BooleanSetting = BooleanSetting;
class NumberSetting extends Setting {
    constructor() {
        super(...arguments);
        this.step = undefined;
        this.defaultValue = 0;
        this.minValue = undefined;
        this.maxValue = undefined;
    }
    extract(value) {
        return DecimalSetting.extract(value);
    }
    hydrate(value) {
        return DecimalSetting.hydrate(value);
    }
}
exports.NumberSetting = NumberSetting;
class IntegerSetting extends NumberSetting {
    constructor() {
        super(...arguments);
        this.step = 1;
    }
    extract(value) {
        return IntegerSetting.extract(value);
    }
    hydrate(value) {
        return IntegerSetting.hydrate(value);
    }
    static extract(value) {
        const isInt = ("" + parseInt("" + value)) === ("" + value);
        return !isInt ? "" : "" + Number.parseInt("" + value);
    }
    static hydrate(value) {
        const isInt = ("" + parseInt("" + value)) === ("" + value);
        return isInt
            ? Number.parseInt("" + value)
            : null;
    }
}
exports.IntegerSetting = IntegerSetting;
class DecimalSetting extends NumberSetting {
    constructor() {
        super(...arguments);
        this.decimals = undefined;
    }
    extract(value) {
        return DecimalSetting.extract(value, this.decimals);
    }
    hydrate(value) {
        return DecimalSetting.hydrate(value, this.decimals);
    }
    static extract(value, decimals = undefined) {
        const isFloat = ("" + parseFloat("" + value)) === ("" + value);
        if (isFloat) {
            return "" + (decimals !== undefined ? Number.parseFloat("" + value).toFixed(decimals) : Number.parseFloat("" + value));
        }
        else {
            return "";
        }
    }
    static hydrate(value, decimals = undefined) {
        const isFloat = ("" + parseFloat("" + value)) === ("" + value);
        if (isFloat) {
            value = parseFloat("" + value);
            if (decimals !== undefined) {
                return parseFloat(parseFloat("" + value).toFixed(decimals));
            }
            else {
                return parseFloat("" + value);
            }
        }
        else {
            return null;
        }
    }
}
exports.DecimalSetting = DecimalSetting;
class NumberRangeSetting extends NumberSetting {
    constructor() {
        super(...arguments);
        this.showInputField = false;
    }
}
exports.NumberRangeSetting = NumberRangeSetting;
class StringSetting extends Setting {
    constructor() {
        super(...arguments);
        this.queryParams = [];
    }
    extract(value) {
        return StringSetting.extract(value);
    }
    static extract(value) {
        return value === undefined || value === null ? "" : ("" + value);
    }
    hydrate(value) {
        return StringSetting.hydrate(value);
    }
    static hydrate(value) {
        if (value !== undefined && value !== null) {
            return ("" + value);
        }
        return null;
    }
}
exports.StringSetting = StringSetting;
class PasswordSetting extends StringSetting {
}
exports.PasswordSetting = PasswordSetting;
class TextSetting extends StringSetting {
    constructor() {
        super(...arguments);
        this.cols = 20;
        this.rows = 2;
    }
}
exports.TextSetting = TextSetting;
class ColorSetting extends StringSetting {
    constructor() {
        super(...arguments);
        this.placement = "auto";
        this.hideColorPalette = false;
        this.hideAlpha = false;
    }
}
exports.ColorSetting = ColorSetting;
class SelectSetting extends StringSetting {
    constructor() {
        super(...arguments);
        this.options = [];
        this.ruleManager = new RuleManager_1.RuleManager();
    }
    getDefaultValue() {
        if (this.defaultValue === undefined && this.options.length > 0) {
            return this.options[0].value;
        }
        return this.defaultValue;
    }
}
exports.SelectSetting = SelectSetting;
class AdvancedSelectSetting extends Setting {
    constructor() {
        super(...arguments);
        this.option_object = {
            label_property: "label",
            value_property: "value",
        };
        this.placeholder = "placeholder";
        this.no_option_text = "no options";
    }
    extract(value) {
        return AdvancedSelectSetting.extract(value);
    }
    hydrate(value) {
        return AdvancedSelectSetting.hydrate(value);
    }
    static extract(value) {
        if (typeof value !== "object")
            return null;
        if (!value)
            return null;
        if ("value" in value && "label" in value) {
            const val = value;
            if (typeof val.value === "string" && typeof val.label === "string") {
                return {
                    value: val.value,
                    label: val.label
                };
            }
        }
        return null;
    }
    static hydrate(value) {
        if (typeof value !== "object")
            return null;
        if (!value)
            return null;
        if ("value" in value && "label" in value) {
            const val = value;
            if (typeof val.value === "string" && typeof val.label === "string") {
                return {
                    value: val.value,
                    label: val.label
                };
            }
        }
        return null;
    }
}
exports.AdvancedSelectSetting = AdvancedSelectSetting;
class MediaLibrarySetting extends Setting {
    constructor(key, label) {
        super(key, label);
        this.defaultValue = null;
        this.origin = "";
        this.mimeGroup = "";
        this.url = null;
        this.thumbnailUrl = null;
        this.fileName = null;
    }
    extract(value) {
        if (typeof value === 'object' && value !== null) {
            if ('url' in value) {
                return Object.assign({ url: value.url, thumbnailUrl: value.thumbnailUrl || null, file_name: value.file_name || null }, value);
            }
        }
        if (typeof value === 'string' && value.trim() !== '') {
            return {
                url: value,
                thumbnailUrl: null,
                file_name: value.split('/').pop() || "media"
            };
        }
        return {
            url: this.url || "",
            thumbnailUrl: this.thumbnailUrl || null,
            file_name: this.fileName || null
        };
    }
    hydrate(value) {
        var _a, _b, _c;
        let url = null;
        let thumbnailUrl = null;
        let fileName = null;
        if (typeof value === "string" && value.trim() !== "") {
            url = value;
            fileName = (_a = value.split("/").pop()) !== null && _a !== void 0 ? _a : "media";
        }
        else if (typeof value === "object" && value !== null && "url" in value) {
            const val = value;
            url = val.url;
            if (!url || url.trim() === "") {
                return {
                    url: "",
                    thumbnailUrl: null,
                    file_name: null
                };
            }
            thumbnailUrl =
                val.preview_url && val.preview_url.trim() !== ""
                    ? val.preview_url
                    : (_b = (val.thumbnailUrl || val.thumbnail_url)) !== null && _b !== void 0 ? _b : null;
            fileName = (_c = (val.file_name || val.fileName || val.name || url.split("/").pop())) !== null && _c !== void 0 ? _c : "media";
        }
        this.url = url;
        this.thumbnailUrl = thumbnailUrl;
        this.fileName = fileName;
        return {
            url: url !== null && url !== void 0 ? url : "",
            thumbnailUrl: thumbnailUrl !== null && thumbnailUrl !== void 0 ? thumbnailUrl : null,
            file_name: fileName !== null && fileName !== void 0 ? fileName : null
        };
    }
    getDefaultValue() {
        var _a;
        if (typeof this.defaultValue === "string" && this.defaultValue.trim() !== "") {
            const cleaned = this.defaultValue.trim();
            return {
                url: cleaned,
                thumbnailUrl: `/api/medialibrary/conversion/thumb${cleaned}`,
                file_name: cleaned.split("/").pop() || "media"
            };
        }
        return {
            url: this.url,
            thumbnailUrl: (_a = this.thumbnailUrl) !== null && _a !== void 0 ? _a : (this.url ? `/api/medialibrary/conversion/thumb${this.url}` : null),
            file_name: this.fileName
        };
    }
}
exports.MediaLibrarySetting = MediaLibrarySetting;
